<template>
  <section class="quick-quote-info">
    <div class="table">
      <div class="tr th">
        <span>Item</span>
        <span>Information</span>
      </div>
      <div class="tr">
        <span>Occupancy</span>
        <span>{{ getAllOptionName26('prop_insured', quoteForm.prop_insured) }}</span>
      </div>
      <div class="tr">
        <span>Gross Floor Area</span>
        <span>{{ quoteForm.floor_area }}</span>
      </div>
      <div class="tr">
        <span>Property Age </span>
        <span>{{ getAllOptionName26('prop_age', quoteForm.prop_age) }}</span>
      </div>
    </div>
    <div class="table">
      <div class="tr th">
        <span>Item</span>
        <span>Information</span>
      </div>
      <div class="tr">
        <span>Type of Building </span>
        <span>{{ getAllOptionName26('bldg_types', quoteForm.bldg_typ) }}</span>
      </div>
      <div class="tr">
        <span>Coverage</span>
        <span>{{ getAllOptionName26('coverage', quoteForm.coverage_id) }}</span>
      </div>
    </div>
  </section>
</template>
<script>
import MixinOptions from '@/mixins/options'
import MixinFormat from '@/mixins/format'
export default {
  name: 'HousemaidQuickQuoteInfo',
  mixins: [MixinOptions, MixinFormat],
  props: {
    quoteForm: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
            
    }
  }
}
</script>
<style lang="scss" scoped>
.quick-quote-info {
    display: flex;
    justify-content: space-between;
    .table {
        width: calc(50% - 10px);
    }
}
</style>